import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';

export const PayByCreditCardContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "pages/orgDashboard/PayByCreditCardContainer" */
      './PayByCreditCardContainer'
    ),
});
